import Template from "./card.vue";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";

let globalOptions = {
  show: false,
  closable: true,
  error: false,
  title: "",
  avatar: "",
  params: [],
  actions: [],
  expanded: false,
  callBackSave: function() {},
  callBackEdit: function() {},
  callBackRemove: function() {},
  callBackClose: function(self) {
    self.$card.close();
  }
};

let instance;

const Card = function(config = {}) {
  let Tpl = this.extend(Template);
  instance = new Tpl();
  config = {
    ...globalOptions,
    ...config
  };
  for (let key in config) {
    if (config.hasOwnProperty(key)) {
      instance.$data[key] = config[key];
    }
  }
  instance.$data.show = true;
  document.body.style.overflow = "hidden";
  document.body.appendChild(instance.$mount().$el);
};

const Close = function(config = {}) {
  instance.$data.show = false;
  document.body.removeChild(instance.$mount().$el);
  instance = undefined;
};

const Person = function(person, callback) {
  let personConfig = {
    type: "person",
    show: true,
    title: i18n.t("persons.label"),
    avatar:
      typeof person.avatar !== "undefined" ? person.avatar : "/img/avatar.svg",
    params: [
      { type: "string", value: person.name, style: "strong" },
      {
        type: "role",
        value: person.role.contact_type_id,
        style: "r" + person.role.contact_type_id
      },
      { type: "email", value: person.email },
      { type: "phone", value: person.phone }
    ],
    actions: [
      {
        type: "profile",
        label: i18n.t("go_profile"),
        url: {
          name:
            (typeof person.event !== "undefined" && person.event != null
              ? "event_"
              : "") + "persons_card",
          params: {
            id: person.id,
            event:
              typeof person.event !== "undefined" && person.event != null
                ? person.event.name
                : null
          }
        }
      },
      {
        type: "edit",
        label: i18n.t("edit"),
        url: { name: "persons_edit", params: { id: person.id } }
      }
    ]
  };

  if (person.role.contact_type_id == 107) {
    personConfig.params.push({
      type: "string",
      value: person.role.number,
      label: "dorsal"
    });
    personConfig.params.push({
      type: "string",
      value: store.getters["persons/getPosition"](person.role.position).name,
      label: "player.position"
    });
    personConfig.params.push({
      type: "string",
      value: person.role.altura,
      label: "tall"
    });
  }

  Card.call(this, {
    ...globalOptions,
    ...personConfig
  });
};

const Team = function(team, is_rel, id_rel, callback) {
  var aParams = [
    { type: "string", value: team.name },
    {
      type: "club",
      value: team.club.name,
      url: { name: "clubs_card", params: { id: team.club.id } }
    }
  ];
  if (typeof team.event !== "undefined")
    aParams.push({ type: "string", value: team.event.name });
  if (typeof team.category !== "undefined")
    aParams.push({ type: "string", value: team.category.name });
  if (typeof team.person !== "undefined")
    aparams.push({
      type: "person",
      value: team.person.name,
      url: { name: "persons_card", params: { id: person.id } }
    });

  let teamConfig = {
    type: "team",
    title: i18n.t("teams.label"),
    avatar:
      typeof team.club.shield !== "undefined"
        ? team.club.shield
        : "./img/shield.svg",
    params: aParams,
    actions: [
      {
        type: "profile",
        label: i18n.t("go_profile"),
        url: {
          name: "event_teams_card",
          params: {
            id: team.id,
            event: (
              team.event.name + team.event.edition.substring(2)
            ).toLowerCase()
          }
        }
      },
      // { type: 'edit', label: i18n.t( 'edit' ), url: { name: 'team_edit', params: { id: team.id } } }
      {
        type: "remove",
        label: i18n.t("teams.actions.remove"),
        action: "remove_rel",
        visible: is_rel
      }
    ]
  };

  teamConfig.callBackRemove = function(self, store) {
    //TODO SHOW ALERT CONFIRM REMOVE RELATIONSHIP

    store.dispatch("teams/remove", team.id).then(function(response) {
      store.dispatch("clubs/load_by_id", { id: team.club.id }).then(function() {
        self.$card.close();
      });
    });
  };

  Card.call(this, {
    ...globalOptions,
    ...teamConfig
  });
};

const Club = function(club, is_rel, id_rel, callback) {
  var aParams = [{ type: "string", value: club.name }];

  var is_rel = typeof is_rel !== "undefined" ? is_rel : false;

  let clubConfig = {
    type: "club",
    title: i18n.t("clubs.label"),
    avatar:
      typeof club.shield !== "undefined" ? club.shield : "./img/shield.svg",
    params: aParams,
    actions: [
      {
        type: "profile",
        label: i18n.t("go_profile"),
        url: { name: "clubs_card", params: { id: club.id } }
      },
      {
        type: "edit",
        label: i18n.t("edit"),
        url: { name: "club_edit", params: { id: club.id } },
        visible: !is_rel
      },
      {
        type: "remove",
        label: i18n.t("remove_relationship"),
        action: "remove_rel",
        visible: is_rel
      }
    ]
  };

  clubConfig.callBackRemove = function(self, store) {
    //TODO SHOW ALERT CONFIRM REMOVE RELATIONSHIP
    store
      .dispatch("persons/removeRelationship", {
        person_id: router.history.current.params.id,
        relation_id: id_rel
      })
      .then(function(response) {
        self.$card.close();
      });
  };

  Card.call(this, {
    ...globalOptions,
    ...clubConfig
  });
};

const RelClubEvent = function(params) {
  let clubConfig = {
    type: "relclubevent",
    title: i18n.t("clubs.rel_club_event"),
    params: {
      club: {
        id: "club",
        type: "select",
        value: typeof params.club_id !== "undefined" ? params.club_id : -1,
        disabled: typeof params.club_id !== "undefined" ? true : false
      },
      event: {
        id: "event",
        type: "select",
        value: typeof params.event_id !== "undefined" ? params.event_id : -1,
        disabled: typeof params.event_id !== "undefined" ? true : false
      },
      user: {
        id: "user",
        type: "select",
        value: typeof params.user_id !== "undefined" ? params.user_id : -1,
        disabled: typeof params.user_id !== "undefined" ? true : false
      }
    },
    actions: [
      { type: "save", label: i18n.t("save"), action: "save", visible: true },
      { type: "close", label: i18n.t("close"), action: "close", visible: true }
    ]
  };

  clubConfig.callBackSave = params.callBack;

  Card.call(this, {
    ...globalOptions,
    ...clubConfig
  });
};

const RelFacilityEvent = function(params) {
  let clubConfig = {
    type: "relfacilityevent",
    title: i18n.t("facilitys.rel_facility_event"),
    params: {
      facility: {
        id: "facility",
        type: "select",
        value:
          typeof params.facility_id !== "undefined" ? params.facility_id : -1,
        disabled: typeof params.facility_id !== "undefined" ? true : false
      },
      event: {
        id: "event",
        type: "select",
        value: typeof params.event_id !== "undefined" ? params.event_id : -1,
        disabled: typeof params.event_id !== "undefined" ? true : false
      }
    },
    actions: [
      { type: "save", label: i18n.t("save"), action: "save", visible: true },
      { type: "close", label: i18n.t("close"), action: "close", visible: true }
    ]
  };

  clubConfig.callBackSave = params.callBack;

  Card.call(this, {
    ...globalOptions,
    ...clubConfig
  });
};

const RelHotelEvent = function(params) {
  let clubConfig = {
    type: "relhotelevent",
    title: i18n.t("hotels.rel_hotel_event"),
    params: {
      hotel: {
        id: "hotel",
        type: "select",
        value: typeof params.hotel_id !== "undefined" ? params.hotel_id : -1,
        disabled: typeof params.hotel_id !== "undefined" ? true : false
      },
      event: {
        id: "event",
        type: "select",
        value: typeof params.event_id !== "undefined" ? params.event_id : -1,
        disabled: typeof params.event_id !== "undefined" ? true : false
      }
    },
    actions: [
      { type: "save", label: i18n.t("save"), action: "save", visible: true },
      { type: "close", label: i18n.t("close"), action: "close", visible: true }
    ]
  };

  clubConfig.callBackSave = params.callBack;

  Card.call(this, {
    ...globalOptions,
    ...clubConfig
  });
};

const AssignTeamToTmpl = function(params) {
  let tmlTeamConf = {
    type: "assignteamtmpl",
    title: i18n.t("competition.group.rel_team_to_tmpl"),
    params: {
      team: {
        id: "team",
        type: "select",
        value: typeof params.team_id !== "undefined" ? params.team_id : -1,
        disabled: false
      },
      tmpl_team: {
        id: "tmpl_team",
        type: "select",
        value:
          typeof params.tmpl_team_id !== "undefined" ? params.tmpl_team_id : -1,
        disabled: typeof params.tmpl_team_id !== "undefined" ? true : false
      },
      event_id: params.event_id,
      category_item: params.item,
      is_groups: typeof params.is_groups !== "undefined" ? params.is_groups : true
    },
    actions: [
      { type: "save", label: i18n.t("assign"), action: "save", visible: true },
      { type: "close", label: i18n.t("close"), action: "close", visible: true }
    ]
  };

  tmlTeamConf.callBackSave = params.callBack;

  Card.call(this, {
    ...globalOptions,
    ...tmlTeamConf
  });
};
const RelVolunteerEvent = function(params) {
  let volunteerConfig = {
    type: "relvolunteerevent",
    title: i18n.t("volunteers.rel_volunteer_event"),
    params: {
      event: {
        id: "event",
        type: "select",
        value: typeof params.event_id !== "undefined" ? params.event_id : -1,
        disabled: typeof params.event_id !== "undefined" ? true : false
      }
    },
    actions: [
      { type: "save", label: i18n.t("save"), action: "save", visible: true },
      { type: "close", label: i18n.t("close"), action: "close", visible: true }
    ]
  };

  volunteerConfig.callBackSave = params.callBack;

  Card.call(this, {
    ...globalOptions,
    ...volunteerConfig
  });
};

const UserZonaEquipos = function(params) {
  let clubConfig = {
    type: "userze",
    title:
      typeof params.club_id !== "undefined"
        ? i18n.t("clubs.user_zonaequipos")
        : i18n.t("teams.user_zonaequipos"),
    params: {
      club: {
        id: "club",
        type: "select",
        value: typeof params.club_id !== "undefined" ? params.club_id : -1,
        disabled: typeof params.club_id !== "undefined" ? true : false
      },
      team: {
        id: "team",
        type: "select",
        value: typeof params.team_id !== "undefined" ? params.team_id : -1,
        disabled: typeof params.team_id !== "undefined" ? true : false
      },
      event: {
        id: "event",
        type: "select",
        value: typeof params.event_id !== "undefined" ? params.event_id : -1,
        disabled: typeof params.event_id !== "undefined" ? true : false
      },
      username: {
        id: "username",
        type: "string",
        value: typeof params.username !== "undefined" ? params.username : ""
      },
      name: {
        id: "name",
        type: "string",
        value: typeof params.name !== "undefined" ? params.name : ""
      },
      password: {
        id: "password",
        type: "password",
        value: typeof params.password !== "undefined" ? params.password : ""
      },
      email: {
        id: "email",
        type: "string",
        value: typeof params.email !== "undefined" ? params.email : ""
      },
      lang: {
        id: "lang",
        type: "select",
        value: typeof params.lang !== "undefined" ? params.lang : -1
      }
    },
    actions: [
      { type: "save", label: i18n.t("save"), action: "save", visible: true },
      { type: "close", label: i18n.t("close"), action: "close", visible: true }
    ]
  };

  clubConfig.callBackSave = params.callBack;

  Card.call(this, {
    ...globalOptions,
    ...clubConfig
  });
};

const Note = function(note, callback) {
  let noteConfig = {
    type: "note",
    show: true,
    title: i18n.t("notes.label"),
    params: [
      {
        id: "note",
        type: "textarea",
        value: typeof note.note !== "undefined" ? note.note : "",
        style: typeof note.id !== "undefined" ? "disabled" : "enable"
      },
      {
        id: "user",
        type: "string",
        value: typeof note.user !== "undefined" ? note.user.name : "-",
        style: "strong",
        visible: typeof note.user !== "undefined"
      },
      {
        id: "date",
        type: "date",
        value: typeof note.date !== "undefined" ? note.date : "-",
        style: "",
        visible: typeof note.date !== "undefined"
      },
      {
        id: "event",
        type: "string",
        value: typeof note.event !== "undefined" ? note.event.name : "-",
        style: "",
        visible: typeof note.event !== "undefined"
      }
    ],
    actions: [
      {
        type: "edit",
        label: i18n.t("edit"),
        action: "edit_note",
        visible: typeof note.id !== "undefined"
      },
      {
        type: "save",
        label: i18n.t("save"),
        action: "save_note",
        visible: typeof note.id === "undefined"
      }
    ],
    callBackSave: function(self, data, store) {
      var oNote = {
        id: note.id,
        note: data.note,
        entity: note.current_page,
        entity_id: note.current_id
      };

      store.dispatch("notes/uploadNote", oNote).then(function(response) {
        self.$card.close();
        if (response.status) {
          store.commit(note.current_page + "s/addNote", {
            id: note.current_id,
            note: response.data
          });
        }
      });
    },
    callBackRemove: function(self, store) {
      store.dispatch("notes/removeNote", note.id).then(function(response) {
        self.$card.close();
        if (response.status) {
          store.commit(note.current_page + "s/removeNote", {
            id: note.current_id,
            note: note.id
          });
          self.$card.close();
        }
      });
    }
  };

  if (typeof note.id !== "undefined") {
    noteConfig.actions.push({
      type: "remove",
      label: i18n.t("remove"),
      action: "remove_note"
    });
  }

  Card.call(this, {
    ...globalOptions,
    ...noteConfig
  });
};

const ContactRel = function(contact_rel, callback) {
  let contactrelConfig = {
    show: true,
    title: i18n.t("contact_relationship.new.label"),
    type: "contact_rel",
    actions: [
      {
        type: "save",
        label: i18n.t("save"),
        action: "save_rel",
        disabled: true
      }
    ],
    callBackSave: function(self, data, store) {
      var valid = true;
      var error = [];
      if (!self.$children[0].entity_type) {
        valid = false;
        error.push(i18n.t("contact_relationship.error.miss_entity_type"));
      } else {
        if (!self.$children[0].entity_id) {
          valid = false;
          error.push(i18n.t("contact_relationship.error.miss_entity_id"));
        }
        if (self.$children[0].entity_type == 2 && !self.$children[0].event_id) {
          valid = false;
          error.push(i18n.t("contact_relationship.error.miss_event"));
        }
      }
      //TODO VALIDATION

      if (valid) {
        var info_rel_person = {
          club_id:
            self.$children[0].entity_type == 1
              ? self.$children[0].entity_id
              : null,
          team_id:
            self.$children[0].entity_type == 2
              ? self.$children[0].entity_id
              : null,
          hotel_id:
            self.$children[0].entity_type == 3
              ? self.$children[0].entity_id
              : null,
          facility_id:
            self.$children[0].entity_type == 4
              ? self.$children[0].entity_id
              : null,
          company_id:
            self.$children[0].entity_type == 5
              ? self.$children[0].entity_id
              : null,
          event_id: self.$children[0].event_id
            ? self.$children[0].event_id
            : null,
          contact_type_id: self.$children[0].contact_type,
          level: self.$children[0].level,
          tall: self.$children[0].tall,
          number: self.$children[0].number,
          position: self.$children[0].position,
          b_medication: self.$children[0].b_medication,
          medication: self.$children[0].medication,
          swim: self.$children[0].swim
        };

        store
          .dispatch("persons/addRelationship", {
            id: contact_rel.current_id,
            data: info_rel_person
          })
          .then(function(response) {
            self.$card.close();
          });
      } else {
        self.showError(error);
      }
    }
  };

  Card.call(this, {
    ...globalOptions,
    ...contactrelConfig
  });
};

const Finances = function(transaction, callback) {
  var aParams = [];
  aParams["transaction_id"] = transaction.id;
  aParams["payments"] = {
    summary: [],
    total: 0
  };

  let transactionConfig = {
    type: "finance",
    title:
      transaction.status == 1
        ? i18n.t("finances.conciliate.undo")
        : i18n.t("finances.conciliate.label"),
    params: aParams,
    actions: [
      {
        type: "save",
        label: i18n.t("conciliate"),
        action: "save",
        visible: transaction.status == 1 ? false : true
      }
    ],
    callBackSave: (self, data, store) => {
      var total = self.params.payments.total;
      var summary = { ...self.params.payments.summary };
      var transaction = {
        ...store.getters["finances/get_transaction_by_id"](
          aParams["transaction_id"]
        )
      };
      if (total != transaction.import) {
        self.showError([i18n.t("error.import")]);
      } else {
        self.showError(false);
        let payload = {
          transaction_id: aParams["transaction_id"],
          payments: JSON.stringify({
            summary,
            total
          })
        };
        store.dispatch("finances/conciliate", payload).then(function() {
          store.dispatch("finances/loadList").then(function() {
            self.$popup.alert({
              message: i18n.t("finances.conciliate.complete"),
              btnSuccess: i18n.t("accept"),
              btnError: i18n.t("cancel")
            });
            self.$card.close();
          });
        });
      }
    },
    callBackRemove: callback
  };

  Card.call(this, {
    ...globalOptions,
    ...transactionConfig
  });
};

const AssignParticipantCampus = function(params) {
  let assignParticipant = {
    type: "assignparticipantcampus",
    title: i18n.t("campus.assign_participant_week_campus"),
    params: {
      event_id: params.event_id
    },
    actions: [
      { type: "save", label: i18n.t("assign"), action: "save", visible: true },
      { type: "close", label: i18n.t("close"), action: "close", visible: true }
    ]
  };

  assignParticipant.callBackSave = params.callBack;

  Card.call(this, {
    ...globalOptions,
    ...assignParticipant
  });
};

const AssignPlayerMatch = function(params) {
    let assignPlayer = {
      type: "assignplayermatch",
      title: i18n.t("assign_player_match"),
      params: {
        event_id: params.event_id,
        player: params.player,
        team: params.team
      },
      actions: [
        { type: "save", label: i18n.t("assign"), action: "save", visible: true },
        { type: "close", label: i18n.t("close"), action: "close", visible: true }
      ]
    };
  
    assignPlayer.callBackSave = params.callBack;
  
    Card.call(this, {
      ...globalOptions,
      ...assignPlayer
    });
  };

const Dismiss = () => {
  instance.$data.show = false;
  document.body.style.overflow = "auto";
};

export default {
  install(Vue) {
    Vue.prototype.$card = Card.bind(Vue);
    Vue.prototype.$card.person = Person.bind(Vue);
    Vue.prototype.$card.team = Team.bind(Vue);
    Vue.prototype.$card.club = Club.bind(Vue);
    Vue.prototype.$card.note = Note.bind(Vue);
    Vue.prototype.$card.contactrel = ContactRel.bind(Vue);
    Vue.prototype.$card.relClubEvent = RelClubEvent.bind(Vue);
    Vue.prototype.$card.relVolunteerEvent = RelVolunteerEvent.bind(Vue);
    Vue.prototype.$card.userZE = UserZonaEquipos.bind(Vue);
    Vue.prototype.$card.finances = Finances.bind(Vue);
    Vue.prototype.$card.assignTeamToTmpl = AssignTeamToTmpl.bind(Vue);
    Vue.prototype.$card.relFacilityEvent = RelFacilityEvent.bind(Vue);
    Vue.prototype.$card.relHotelEvent = RelHotelEvent.bind(Vue);
    Vue.prototype.$card.assignParticipantCampus = AssignParticipantCampus.bind(Vue);
    Vue.prototype.$card.assignPlayerMatch = AssignPlayerMatch.bind(Vue);

    Vue.prototype.$card.close = Close.bind(Vue);
  }
};
